import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { logOut, updateLocalStorageToken } from '../../../../../containers/resources/utils';

export const flightRouteSlice = createSlice({
  name: 'flightRoute',
  initialState: {
    routes: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  },
  reducers: {
    initialStateFlightRoutes(state, action) {
      return {
        routes: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    requesFlightRoutes(state, action) {
      return {
        routes: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      }
    },
    fetchFlightRoutesSuccess(state, action) {
      return {
        routes: action.payload,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    flightRoutesMessage(state, action) {
      return {
        routes: [],
        processing: false,
        fetching: false,
        message: action.payload,
        error: "",
      }
    },
    flightRoutesError(state, action) {
      return {
        routes: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.payload,
      }
    }
  }
})

export const fetchFlightRoutes = (flight_id) => dispatch => {
  dispatch(requesFlightRoutes());
  axios.get(`/flightsRoutes/${flight_id}/routes`)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(fetchFlightRoutesSuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchFlightRoutes(flight_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(flightRoutesError(json.data.data));
      }
    })
};

export const createRoutes = (flight_id, data) => dispatch => {
  dispatch(requesFlightRoutes());
  axios.post(`/flightsRoutes/${flight_id}/createRoute`, data)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(flightRoutesMessage(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(createRoutes(flight_id, data));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(flightRoutesError(json.data.data));
      }
    })
};

export const deleteRoute = (flight_route_id) => dispatch => {
  dispatch(requesFlightRoutes());
  axios.delete(`/flightsRoutes/delete/route/${flight_route_id}`)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(flightRoutesMessage(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(deleteRoute(flight_route_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(flightRoutesError(json.data.data));
      }
    })
};

export const {
  initialStateFlightRoutes,
  requesFlightRoutes,
  fetchFlightRoutesSuccess,
  flightRoutesMessage,
  flightRoutesError,
} = flightRouteSlice.actions;

export default flightRouteSlice.reducer;